var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tool-bar'),_c('main',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('foot-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }